import Vue from 'vue';
import Router from 'vue-router';

//首页
import Index from '@/view/index/index';
//二级页面
import Column from '@/view/column/index';
//详情页面
import Detail from '@/view/detail/index';
//能源二级页
import Encolumn from '@/view/encolumn/index';
//交易数据二级页
import Trancolumn from '@/view/trancolumn/index';
//排放数据二级页
import Discolumn from '@/view/discolumn/index';
//产品数据(绿色金融)二级页
import Lvcolumn from '@/view/lvcolumn/index';
//产品介绍
import Introduce from '@/view/introduce/index';
//上线通知
import IntroduceOnLine from '@/view/introduce/indexOnLine';
//信息定制
import Infor from '@/view/infor/index';
//课题咨询index
import Topic from '@/view/topic/index';
//热点页面
import hotColumn from '@/view/hotcolumn/index';
//热点详情页面
import hotDetail from '@/view/hotcolumn/hotdetail/index';
//动态资讯
import dynamicInfo from '@/view/dynamicInfo/index';
//学术论文
import paper from '@/view/paper/index';
//行动方案
import actionPlan from '@/view/actionPlan/index';
//5周年
import fiveth from '@/view/fiveth/index';
Vue.use(Router);

export default new Router({
	routes: [
		{
			path: '/',
			redirect: '/Index',
		},
		{
			//首页
			path: '/index',
			component: Index,
		},
		{
			//二级页
			path: '/column',
			component: Column,
		},
		{
			//热点二级页
			path: '/hotColumn',
			component: hotColumn,
		},
		{
			//热点详情
			path: '/hotDetail',
			component: hotDetail,
		},
		{
			//详情页
			path: '/detail',
			component: Detail,
		},
		{
			//能源二级页
			path: '/encolumn',
			component: Encolumn,
		},
		{
			//交易二级页
			path: '/trancolumn',
			component: Trancolumn,
		},
		{
			//排放数据二级页
			path: '/discolumn',
			component: Discolumn,
		},
		{
			//产品数据(绿色金融)二级页
			path: '/lvcolumn',
			component: Lvcolumn,
		},
		{
			//产品介绍
			path: '/introduce',
			component: Introduce,
		},
		{
			//上线通知
			path: '/IntroduceOnLine',
			component: IntroduceOnLine,
		},
		{
			//信息定制
			path: '/infor',
			component: Infor,
		},
		{
			//课题咨询
			path: '/topic',
			component: Topic,
		},
		{
			//动态资讯
			path: '/dynamicInfo',
			component: dynamicInfo,
		},
		{
			//学术论文
			path: '/paper',
			component: paper,
		},
		{
			//行动方案
			path: '/actionPlan',
			component: actionPlan,
		},
		{
			//5周年
			path: '/fiveth',
			component: fiveth,
		},
	],
});



// WEBPACK FOOTER //
// ./src/router/index.js